import createMetas from './createMetas';

const DEFAULT_TWITTER_SITE = '@Spotahome';

const DEFAULT_PROPERTIES = {
  site: DEFAULT_TWITTER_SITE
};

const PROPERTIES_MAP = {
  card: 'twitter:card',
  site: 'twitter:site',
  title: 'twitter:title',
  description: 'twitter:description',
  imageSrc: 'twitter:image:src',
  url: 'twitter:url'
};

export const createTwitterMetas = (props = {}) =>
  createMetas(props, DEFAULT_PROPERTIES, PROPERTIES_MAP);

export default {
  createTwitterMetas,
  DEFAULT_TWITTER_SITE
};
